import {createSelector} from '@ngrx/store';

import * as fromApprovalFlowsReducer from './approval-flow.reducer';
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromApprovalFlowsReducer.approvalFlowsFeatureKey]);

export const selectAllApprovalFlows = createSelector(currentState, fromApprovalFlowsReducer.selectAll);

export const selectTotalApprovalFlows = createSelector(currentState, fromApprovalFlowsReducer.selectTotal);

export const selectModifiedApprovalFlows = createSelector(selectAllApprovalFlows, (approvalFlows) => {
  return approvalFlows.map((approval) => {
    return {
      ...approval,
      modFlowProcess: approval?.flowProcess?.replaceAll('_',' ')
    };
  });
});

export const selectModifiedApprovalFlowByUuid = (uniqueId: string) => createSelector(selectModifiedApprovalFlows, (approvalFlows) => {
  return approvalFlows.find(a => a.flowUniqueId === uniqueId)
});
